import { ButtonHTMLAttributes, ReactNode } from "react";
import { ValueOf } from "utils/typeCheck.utils";

export const BUTTON_VARIANT = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary",
  ONLY_ICON: "only-icon",
  ONLY_ICON_TRANSPARENT: "only-icon-transparent",
} as const;

export const BUTTON_SIZE = {
  L: "large",
} as const;

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: ValueOf<typeof BUTTON_VARIANT>;
  size?: ValueOf<typeof BUTTON_SIZE>;
  className?: string;
  disabled?: boolean;
  active?: boolean;
}
